import { createSlice } from "@reduxjs/toolkit";
import { VIDEO_TYPE } from "../../../Common/constants";
const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  importLoading: false,
  totalCount: 0,
  entities: [],
  productForEdit: {},
  productTaxes: [],
  productDetails: {
    description: undefined,
    images: undefined,
    video: undefined,
    name: undefined,
  },
  promotionEntities: [],
  attributes: [],
  attributesGroups: [],
  sku: undefined,
  tags: undefined,
  checkedCategories: null,
  rejectedProducts: null,
  succeedCount: null,
  failedCount: null,
  totalImport: null,
  currentImport: null,
  isDownLoading: false,
  status: null,
  exportStatus: null,
  printLabelStatus: null,
  printLabelURL: null,
  exportURL: null,
  ImportStatus: null,
  ImportUrl: null,
  importFile: null,
  traceback: null,
  suppliers: null,
  brand: null,
  brand_id: null,
  error: null,
  importLocations: null,
  importSuccess: false,
  images: [],
  video: undefined,
  uploadType: "",
  productLogsExportStatus:null,
  productLogsExportUrl:null,
  paramInfoForProductTable: {
    pageNumber: +(localStorage.getItem('productTablePageNo')  ?? 1),
    pageSize: +(localStorage.getItem('productTablePageSize')  ?? 20),
  },
  message: {
    error: null,
    success: null,
  },
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const productsSlice = createSlice({
  name: "products",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error?.constructor?.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportURL = url;
    },
    updatePrintLabelStatus: (state, action) => {
      const { status, url } = action.payload;
      state.printLabelStatus = status;
      state.printLabelURL = url;
    },
    updateDownLoadingStatus: (state, action) => {
      state.isDownLoading = action.payload;
    },
    updateImportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.ImportStatus = status;
      state.ImportUrl = url;
    },
    // getProductById
    productFetched: (state, action) => {
      var { productForEdit } = action.payload;
      state.actionsLoading = false;
      if (productForEdit?.video_type == VIDEO_TYPE.VIDEO.value) {
        state.video = { url: productForEdit.video, file: { preview: productForEdit.video } };
        delete productForEdit.video;
      }
      if (productForEdit === undefined) {
        state.productForEdit = productForEdit;
      } else {
        var productEditData = productForEdit;
        if (productEditData.weight == null) {
          productEditData.weight = 0;
          productEditData.weight_unit = 1;
        }
        state.checkedCategories = productEditData.categories;
        state.suppliers = productEditData.suppliers || [];
        state.tags = productEditData.tags || [];
        state.productForEdit = productEditData;
        state.brand = productEditData.brand || "";
        state.attributes = productEditData.attributes;
        state.attributesGroups = productEditData.attribute_groups;
        state.images = productForEdit.images.map((row) => {
          return {
            file: { preview: row },
            url: row,
          };
        });
      }
      state.error = null;
    },
    // findProducts
    productsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    updateSingleProduct: (state, action) => {
      const { entity } = action.payload;
      const productIndex = state.entities.findIndex((el) => el.id == entity.id)
      if (productIndex > -1) {
        state.entities[productIndex] = entity;
      }
    },
    // scrollingProductsInCatalog
    scrollProductsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = [...state.entities, ...entities];
      state.totalCount = totalCount;
    },

    // findAttributes
    attributesFetched: (state, action) => {
      const { attributes, attribute_groups } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      const attr = [];
      const attrGroup = [];
      for (let attribute of attributes) {
        let pushed = true;
        for (let stateAttribute of state.attributes) {
          if (stateAttribute.category_id === attribute.category_id && stateAttribute.id === attribute.id) {
            attr.push(stateAttribute);
            pushed = false;
            break;
          }
        }
        if (pushed) {
          attr.push(attribute);
        }
      }
      for (let attributeGroup of attribute_groups) {
        let pushed = true;
        for (let stateAttributeGroup of state.attributesGroups) {
          if (stateAttributeGroup.category_id === attributeGroup.category_id && stateAttributeGroup.id === attributeGroup.id) {
            attrGroup.push(stateAttributeGroup);
            pushed = false;
            break;
          }
        }
        if (pushed) {
          attrGroup.push(attributeGroup);
        }
      }
      state.attributes = attr;
      state.attributesGroups = attrGroup;
    },
    // import products status
    setImportProductState: (state, action) => {
      const { id, status, traceback, result = null } = action.payload;
      state.status = status;
      const importStatus = {
        id: id,
        status: status,
        traceback: traceback,
        result: result,
      };
      localStorage.setItem("importStatus", JSON.stringify(importStatus));
    },
    // createProduct
    productCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { message, product } = action.payload;
      state.message.success = message;
      state.entities.push(product);
    },
    // updateProduct
    productUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message.success = action.payload.message;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.product.id) {
          return action.payload.product;
        }
        return entity;
      });
      state.video = undefined;
      state.images = [];
    },
    // deleteProduct
    productDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => el.id !== action.payload.id);
    },

    // deleteProducts
   productsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },

    productRestored: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },

    CheckedCategories: (state, action) => {
      state.checkedCategories = action.payload.checkedCategories;
    },
    productDescription: (state, action) => {
      state.productDetails.description = action.payload.description;
    },
    productImages: (state, action) => {
      state.productDetails.images = action.payload.images;
    },
    productVideo: (state, action) => {
      state.productDetails.video = action.payload.video;
    },
    // failed Products
    failedProducts: (state, action) => {
      const { result, status, traceback } = action.payload;
      state.listLoading = false;
      state.rejectedProducts = result?.rejectedProducts;
      state.succeedCount = result?.succeed;
      state.failedCount = result?.failed;
      state.totalImport = result?.total;
      state.currentImport = result?.current;
      state.status = status;
      state.traceback = traceback;
      state.importSuccess = true;
    },
    // SKU Generation
    fetchedSKU: (state, action) => {
      state.sku = action.payload.sku;
    },
    locationsImported: (state, action) => {
      const { entity } = action.payload;
      state.importLocations = entity;
      state.actionsLoading = false;
      state.listLoading = false;
    },

    setSuppliers: (state, action) => {
      state.suppliers = action.payload.suppliers;
    },

    updateImportInfo: (state, action) => {
      state.status = null;
      state.rejectedProducts = [];
      state.traceback = null;
      state.failedCount = 0;
      state.succeedCount = 0;
      state.importSuccess = false;
    },
    //Set Product Selected Tags
    setTags: (state, action) => {
      state.tags = action.payload.tags;
    },
    //Reset Product Adding States
    resetStates: (state, action) => {
      state.suppliers = undefined;
      state.checkedCategories = undefined;
      state.productForEdit = undefined;
      state.tags = undefined;
      state.brand = undefined;
      state.sku = undefined;
      state.video = undefined;
      state.images = [];
    },
    setParamsInfoForProduct: (state, action) => {
      state.paramInfoForProductTable = action.payload
    },
    //Set Brand
    setBrand: (state, action) => {
      state.brand = action.payload.brand;
    },
    setBrandId: (state, action) => {
      state.brand_id = action.payload.id;
    },
    setImportProductFile: (state, action) => {
      state.importFile = action.payload.file;
    },
    setImportLoading: (state, action) => {
      state.importLoading = action.payload.importLoading;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
    // update the urls in
    updateUrls: (state, action) => {
      const { url, file, type } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      if (type == "images") {
        state.images = [...state.images, { url: url, file: file }];
      } else {
        state.video = { url: url, file: file };
      }
      state.uploadType = type;
    },
    removeImage: (state, action) => {
      const { obj } = action.payload;
      state.images = state.images.filter((fileObj) => fileObj.url != obj);
    },
    removeVideo: (state, action) => {
      // console.log("remove the video from the redux");
      state.video = null;
      // state.video_link = null;
    },

    setSingleProduct: (state, action) => {
      const { name,deleted_at } = action.payload
      state.productForEdit = { name,deleted_at }
    },
    setProductTaxes: (state, action) => {
      const data = action.payload
      state.productTaxes = data
    },

    updateUploadType: (state, action) => {
      state.uploadType = action.payload.type;
    },
    promotionsFetched: (state, action) => {
      const { entities } = action.payload;
      let promotions = [];
      entities.forEach((entity) => {
        entity.promotion_details.forEach((promoDetail) =>{
          const promotion = {
            ...promoDetail,
            promotion_detail_id: promoDetail.id,
            promotion_id: entity.id,
            name: entity.name,
            start_datetime: entity.start_datetime,
            end_datetime: entity.end_datetime,
            has_sale_badge: entity.has_sale_badge,
            are_all_customers: entity.are_all_customers,
            applicable_for: entity.applicable_for,
            promotion_status: entity.promotion_status,
            customer_group_ids: entity.customer_group_ids,
            promotion_channel_ids: entity.channel_ids,
          }

          promotions.push(promotion);
        });
      });

      state.promotionEntities = promotions;
      state.promotionsTotalCount = promotions.length;
      state.listLoading = false;
    },
    updateProductLogsExportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.productLogsExportStatus = status;
      state.productLogsExportUrl = url;
    },
  },
});
